module.exports = __webpack_public_path__ + "static/img/v5-1.522128ed.png";